import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { MessageService } from "../../services/message.service";
import { MasterService } from "../../services/master.service";
import { StoreService } from "../../services/store.service";
import { SecurityService } from "../../services/security.service";
import * as words from '../../services/language';

@Component({
    selector: "app-accounts",
    templateUrl: "./accounts.component.html",
    styleUrls: ["./accounts.component.scss"],
    standalone: false
})
export class AccountsComponent implements OnInit {
    /** save the language */
    protected language: string = localStorage.getItem('language') ? localStorage.getItem('language') : 'EN'
    
    /** set all words */
    protected words = words.language

    /** Unique internal identity of the lot whose accounts are being displayed. */
    protected lotId: number = 0
    
    /** Unique internal identity of the sale terms currently selected. */
    protected termsId: number = 0

    /** Unique internal identity of the sale currently selected. */
    protected saleId: number = 0

    /** Unique internal identity of the receivable (account) currently selected. */
    protected accountId: number = 0

    constructor(private route: ActivatedRoute, private router: Router, private ms: MessageService, private master: MasterService, public store: StoreService, public security: SecurityService) {}

    ngOnInit() {
        if (localStorage.getItem('lot')) {
            this.lotId = parseInt(localStorage.getItem('lot'))
        }
    }

    // todo: listen to output of navbar
    protected listenerNav = (e): void => {
        switch (e['message']) {
            case 'changeLanguage':
                this.language = e['value']
                break
            case 'changeLot':
                this.lotId = parseInt(e['lot'])
                break
            default:
                break
        }
    }

    /**
     * A user has selected an account to manage.
     * @param meta Information (termsId, saleId, contactId) about the receivable (account) that was clicked by the user.
     */
    protected accountChosen = (meta: Object): void => {
        if (!meta || !meta['termsId']) {
            return
        }

        this.termsId = meta['termsId']
        this.saleId = meta['saleId']
        this.accountId = meta['contactId']
    }
}
